import { NavigationLeafItem, ParentNavigationItem } from '@next/core-lib/navigation';
import { Location } from '@next/core-lib/user';

export interface AppState {
  userNavigationItems?: ParentNavigationItem[];
  customerBrsNumbers: CustomerBrsNumber[];
  customerKvkNumbers: CustomerKvkNumber[];
}

interface UserNavigationMetadata {
  hideForLocales?: string[];
  hideForRoles?: string[];
  applicationKey?: string;
  applicationKeys?: string[];
}

export interface UserNavigationLeafItem extends NavigationLeafItem, UserNavigationMetadata {}

export interface UserNavigationItem extends ParentNavigationItem, UserNavigationMetadata {
  children?: UserNavigationLeafItem[];
}

export interface CustomerBrsNumber {
  relatedLocations: Location[];
  brsNumber: string;
  validFrom: Date;
  validTo: Date;
}

export interface CustomerKvkNumber {
  relatedLocation: Location;
  kvkNumber: string;
}

export enum SettingsKeys {
  brsNumber = 'brsNumber',
  dateRange = 'dateRange',
  locations = 'locations',
  search = 'search',
  totals = 'totals',
  invoiceView = 'invoiceView',
}

export const settingsContextName = 'customer-dashboard';
